import React from 'react';
import Page from '../components/Page';

export interface FilterInterface {
  carType?: string;
  priceOrder?: string;
  available?: string;
}

const NewInventory: React.FC = () => {
  return (
    <>
      <Page title={'Inventory'}>
        <div id='qrbuddy-inventory-root' data-default-inventory-type='New'></div>
      </Page>
    </>
  );
};

export default NewInventory;
